import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "row", "count", "bulkActions"];
  static values = {
    selectedIds: { type: Array, default: [] },
  };

  connect() {
    this.updateUI();
  }

  toggleAll(event) {
    const checked = event.target.checked;
    this.rowTargets.forEach((row) => {
      row.checked = checked;
    });
    this.updateSelectedIds();
  }

  toggleRow() {
    this.updateSelectedIds();
  }

  updateSelectedIds() {
    this.selectedIdsValue = this.rowTargets
      .filter((row) => row.checked)
      .map((row) => row.value);
    this.updateUI();
  }

  updateUI() {
    const total = this.rowTargets.length;
    const selected = this.selectedIdsValue.length;

    // Update select all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = selected === total && total > 0;
      this.selectAllTarget.indeterminate = selected > 0 && selected < total;
    }

    // Update count badge
    if (this.hasCountTarget) {
      this.countTarget.textContent = selected;
      this.countTarget.hidden = selected === 0;
    }

    // Show/hide bulk actions
    if (this.hasBulkActionsTarget) {
      this.bulkActionsTarget.hidden = selected === 0;
    }

    // Dispatch event for external listeners
    this.dispatch("change", {
      detail: {
        selectedIds: this.selectedIdsValue,
        count: selected,
      },
    });
  }

  getSelectedIds() {
    return this.selectedIdsValue;
  }

  clearSelection() {
    this.rowTargets.forEach((row) => {
      row.checked = false;
    });
    this.selectedIdsValue = [];
    this.updateUI();
  }
}
